module.exports = __webpack_public_path__ + "img/collapse-left.a055f164.svg";